import React from 'react';
import PropTypes from 'prop-types';
import { Container, GridItem, Flex, Text, Button, Box } from '@chakra-ui/react';
import { DeptGrid } from '@repo/ui-components/dept/design-system';
import CardBlogStandard from '@repo/ui-components/dept/atoms/CardBlogStandard';
import SimpleSlider from '@repo/ui-components/dept/molecules/SimpleSlider';
import { generateSectionId } from '@repo/ui-components/dept/utils/generateSectionId';
import Link from '@repo/ui-components/tailwind/Link';

function CardBox(post) {
  const { postReference, badge } = post;
  return (
    <Box w="18.87rem">
      <CardBlogStandard badge={badge} article={postReference} />
    </Box>
  );
}

CardBox.propTypes = {
  post: PropTypes.shape({
    badge: PropTypes.shape({
      headline: PropTypes.string,
      copy: PropTypes.string,
      link: PropTypes.shape({
        linkType: PropTypes.string,
        href: PropTypes.string,
        internalLink: PropTypes.shape({
          slug: PropTypes.shape({
            current: PropTypes.string,
          }),
        }),
      }),
      icon: PropTypes.shape({
        asset: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
    }),
    postReference: PropTypes.shape({
      title: PropTypes.string.isRequired,
      articleType: PropTypes.string.isRequired,
      categories: PropTypes.arrayOf(
        PropTypes.shape({
          _key: PropTypes.string,
          title: PropTypes.string,
        })
      ).isRequired,
      image: PropTypes.shape({
        asset: PropTypes.shape({
          url: PropTypes.string.isRequired,
        }),
        alt: PropTypes.string,
      }).isRequired,
      author: PropTypes.shape({
        title: PropTypes.string.isRequired,
        slug: PropTypes.shape({
          current: PropTypes.string.isRequired,
        }).isRequired,
      }),
      slug: PropTypes.shape({
        current: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default function CardRowThreePosts({ block }) {
  return (
    <Container
      {...generateSectionId(block)}
      pt={[8, null, 20]}
      pb={[14, null, 20]}
    >
      <Flex justifyContent="space-between" mb={[6, null, 10]}>
        <Text as="h3" textStyle="h3" fontWeight="black">
          {block.headline}
        </Text>
        {block.cta?.text && (
          <Button
            display={['none', null, 'flex']}
            variant="primary"
            as={Link}
            link={block?.cta?.link}
          >
            {block.cta.text}
          </Button>
        )}
      </Flex>

      <DeptGrid display={['none', null, 'grid']}>
        {block.cards.map(post => (
          <GridItem key={post._key} colSpan={4}>
            <CardBlogStandard badge={post.badge} article={post.postReference} />
          </GridItem>
        ))}
      </DeptGrid>

      <SimpleSlider
        items={block.cards}
        sliderItem={CardBox}
        display={['block', null, 'none']}
      />
      {block.cta?.text && (
        <Button
          display={['flex', null, 'none']}
          w="100%"
          variant="primary"
          as={Link}
          link={block?.cta?.link}
        >
          {block.cta.text}
        </Button>
      )}
    </Container>
  );
}

CardRowThreePosts.propTypes = {
  block: PropTypes.shape({
    headline: PropTypes.string.isRequired,
    cta: PropTypes.shape({
      text: PropTypes.string,
      link: PropTypes.shape({
        linkType: PropTypes.string,
        href: PropTypes.string,
        internalLink: PropTypes.shape({
          slug: PropTypes.shape({
            current: PropTypes.string,
          }),
        }),
      }),
    }),
    cards: PropTypes.arrayOf(
      PropTypes.shape({
        _key: PropTypes.string.isRequired,
        badge: PropTypes.shape({
          headline: PropTypes.string,
          copy: PropTypes.string,
          link: PropTypes.shape({
            linkType: PropTypes.string,
            href: PropTypes.string,
            internalLink: PropTypes.shape({
              slug: PropTypes.shape({
                current: PropTypes.string,
              }),
            }),
          }),
          icon: PropTypes.shape({
            asset: PropTypes.shape({
              url: PropTypes.string,
            }),
          }),
        }),
        postReference: PropTypes.shape({
          _id: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
          articleType: PropTypes.string,
          categories: PropTypes.arrayOf(
            PropTypes.shape({
              _key: PropTypes.string,
              title: PropTypes.string,
            })
          ).isRequired,
          image: PropTypes.shape({
            asset: PropTypes.shape({
              url: PropTypes.string.isRequired,
            }),
            alt: PropTypes.string,
          }).isRequired,
          author: PropTypes.shape({
            title: PropTypes.string.isRequired,
            slug: PropTypes.shape({
              current: PropTypes.string.isRequired,
            }).isRequired,
          }),
          slug: PropTypes.shape({
            current: PropTypes.string.isRequired,
          }).isRequired,
        }),
      })
    ).isRequired,
  }).isRequired,
};
